/* Irish VAT presentation. All calculations start from canonical integer cents. */
(function () {
  'use strict';
  var config = window.SolarbossVatConfig || {};
  var root = document.documentElement;
  var key = 'solarboss-vat-display';
  function amounts(cents, taxable, grossOverride) {
    var net = Math.round(Number(cents) || 0), gross = net;
    if (taxable !== false) {
      if (config.taxesIncluded) net = Math.round(net / 1.23);
      else gross = Math.round(net * 1.23);
    }
    if (grossOverride != null) gross = Math.round(grossOverride);
    return {net: net, gross: gross};
  }
  function money(cents) {
    return new Intl.NumberFormat('en-IE', {style: 'currency', currency: config.currency || 'EUR'}).format(cents / 100);
  }
  function taxable(variant) {
    if (variant && typeof variant.taxable === 'boolean') return variant.taxable;
    return !variant || (config.exemptVariantIds || []).indexOf(String(variant.id)) < 0;
  }
  function html(cents, isTaxable, label, grossOverride) {
    var a = amounts(cents, isTaxable, grossOverride);
    return '<span class="sb-vat-price"><span class="sb-vat-inc">' + money(a.gross) + '</span><span class="sb-vat-ex">' + money(a.net) + '</span>' + (label === false ? '' : '<small class="sb-vat-label">' + (isTaxable === false ? ' VAT exempt' : '<span class="sb-vat-inc"> incl. VAT</span><span class="sb-vat-ex"> ex. VAT</span>') + '</small>') + '</span>';
  }
  function cartGross(cart) {
    if (cart.taxes_included) return cart.total_price;
    return cart.items.reduce(function (sum, item) {return sum + amounts(item.final_line_price, taxable(item)).gross;}, 0);
  }
  function apply(mode, persist) {
    mode = mode === 'ex' ? 'ex' : 'inc';
    root.setAttribute('data-sb-vat', mode);
    if (persist) { try { localStorage.setItem(key, mode); } catch (e) {} }
    document.querySelectorAll('[data-sb-vat-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-sb-vat-choice') === mode));
    });
    document.querySelectorAll('[data-sb-vat-toggle]').forEach(function (button) {
      button.setAttribute('aria-checked', String(mode === 'inc'));
      button.setAttribute('aria-label', mode === 'inc' ? 'Prices include VAT. Switch to prices excluding VAT.' : 'Prices exclude VAT. Switch to prices including VAT.');
    });
    var status = document.getElementById('sb-vat-status');
    if (status) status.textContent = 'Prices ' + (mode === 'inc' ? 'include' : 'exclude') + ' Irish VAT where applicable.';
  }
  window.SolarbossVat = {html: html, amounts: amounts, taxable: taxable, cartGross: cartGross};
  // Luigi's Box renders its own autocomplete after the theme loads. Resolve
  // canonical Shopify cents rather than multiplying an already formatted price.
  var searchProducts = new Map();
  var pendingPrices = new WeakSet();
  var queuedSearch = false;
  function refreshSearchPrices() {
    queuedSearch = false;
    document.querySelectorAll('.luigi-ac-price').forEach(function (price) {
      if (price.querySelector('.sb-vat-price') || pendingPrices.has(price)) return;
      var link = price.closest('a[href*="/products/"]');
      if (!link) return;
      var url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || url.pathname.indexOf('/products/') !== 0) return;
      var path = url.pathname;
      pendingPrices.add(price);
      if (!searchProducts.has(path)) searchProducts.set(path, fetch(path + '.js', {credentials:'same-origin'}).then(function (response) {
        if (!response.ok) throw new Error('Price unavailable');
        return response.json();
      }));
      searchProducts.get(path).then(function (product) {
        if (!price.isConnected) return;
        var variant = product.variants.reduce(function (lowest, v) {return !lowest || v.price < lowest.price ? v : lowest;}, null);
        if (!variant) return;
        var isTaxable = taxable(variant);
        var percent = Number((window.SolarbossTradePricing || {}).discountPercent) || 0;
        var net = Math.round(variant.price * (100 - percent) / 100);
        price.setAttribute('data-sb-price-ready', 'true');
        price.innerHTML = variant.price === 0 ? 'POA' : html(net, isTaxable);
        if (variant.compare_at_price > variant.price && !percent) price.innerHTML += ' <s>' + html(variant.compare_at_price, isTaxable, false) + '</s>';
      }).catch(function () {if (price.isConnected) {price.setAttribute('data-sb-price-ready', 'true');price.textContent = 'View price';}searchProducts.delete(path);}).finally(function () {pendingPrices.delete(price);});
    });
  }
  function observeSearchPrices() {
    refreshSearchPrices();
    new MutationObserver(function (records) {
      if (queuedSearch) return;
      if (records.some(function (record) {
        return record.target.nodeType === 1 && (record.target.closest('.luigi-ac') || Array.from(record.addedNodes).some(function (node) {return node.nodeType === 1 && (node.matches('.luigi-ac') || node.querySelector('.luigi-ac'));}));
      })) {queuedSearch = true; requestAnimationFrame(refreshSearchPrices);}
    }).observe(document.body, {childList:true, subtree:true});
  }

  function init() {
    observeSearchPrices();
    apply(root.getAttribute('data-sb-vat'), false);
    document.querySelectorAll('.sb-vat-controls').forEach(function (el) {el.hidden = false;});
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sb-vat-choice]');
      if (button) apply(button.getAttribute('data-sb-vat-choice'), true);
      var toggle = event.target.closest('[data-sb-vat-toggle]');
      if (toggle) apply(root.getAttribute('data-sb-vat') === 'ex' ? 'inc' : 'ex', true);
    });
    window.addEventListener('storage', function (event) {if (event.key === key) apply(event.newValue, false);});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
